import { useBreakPoints } from 'core';
import { useParams } from 'react-router-dom';
import { Anchor, ButtonMantine, OneToTwoLayoutTemplate, Stack, Title } from 'ui';

import { useShowEntryByProviderId } from '../../../../hooks/queries/Ledger/owner';
import { EntryDetailsCard } from '../components/EntryDetailsCard';
import { EntryList } from '../components/EntryList';

const EarningDetailLeftSection = () => {
  const { entryId } = useParams();
  const { data: entryData } = useShowEntryByProviderId(entryId);
  const { isMediumScreen } = useBreakPoints();

  if (!entryId) {
    return null;
  }

  return (
    <Stack>
      <Title order={2} hiddenFrom="md">{`${entryData?.title} Purchase`}</Title>
      <EntryDetailsCard entryId={entryId} />
      {entryData?.status === 'failed' && !isMediumScreen && (
        <Anchor href={'https://support.givebacks.com/hc/en-us'} target="_blank">
          <ButtonMantine fullWidth>Contact Customer Support</ButtonMantine>
        </Anchor>
      )}
    </Stack>
  );
};
const EarningEntryPage = () => {
  const { entryId } = useParams();
  const { data: entryData } = useShowEntryByProviderId(entryId);

  return (
    <OneToTwoLayoutTemplate
      leftSection={<EarningDetailLeftSection />}
      rightSection={<EntryList entryId={entryId ?? ''} />}
      mobileBottomButton={
        entryData?.status === 'failed' && (
          <Anchor href={'https://support.givebacks.com/hc/en-us'} target="_blank">
            <ButtonMantine fullWidth>Contact Customer Support</ButtonMantine>
          </Anchor>
        )
      }
    />
  );
};

export { EarningEntryPage };
